import { gql } from "@apollo/client";

const RATE_CARD_FRAGMENT = gql`
	fragment RateCardFragment on RateCard {
		rateCardName
		paymentOptions
		discountId
	}
`;

const PRODUCT_PRICE_INFO_FRAGMENT = gql`
	fragment ProductPriceInfoFragment on ProductPriceInfo {
		countryCode
		subPeriodType
		formattedInitialUnitPrice
		formattedInitialSubtotalPrice
		formattedInitialSubtotalPriceBase
		productType
		initialTaxes {
			taxType
			billingTaxRatesUSId
			billingStateCode
			billingCountryCode
			amount
			formattedAmount
		}
		initialCurrency
		subPeriod
		productSubType
		productId
		formattedInitialPrice
		tokensCount
	}
`;

const STORED_PAYMENT_METHODS_FRAGMENT = gql`
	fragment StoredPaymentMethodsFragment on StoredPaymentMethods {
		payPalEmailAddress
		holderName
		cardLastFour
		isValid
		expDate
		tokenId
		paymentProcessor
	}
`;

export const UPGRADE_QUERY = gql`
	${RATE_CARD_FRAGMENT}
	${PRODUCT_PRICE_INFO_FRAGMENT}
	${STORED_PAYMENT_METHODS_FRAGMENT}

	query getBillingUpgradeEligibilityRateCard(
		$userId: String!,
		$platform: Platform!
		$productType: ProductType!,
		$productSubtype: ProductSubType!,
	) {
		user(id: $userId) {
			id
			billingUpgradeEligibility(
				platform: $platform
			) {
				eligibleUpgrades {
					upgradeProducts {
						productPriceInfo {
							...ProductPriceInfoFragment
						}
					}
				}
			}
			rateCard(
				platform: $platform
				productType: $productType
				productSubtype: $productSubtype
			) {
				...RateCardFragment
			}
			storedPaymentMethods {
				...StoredPaymentMethodsFragment
			}
			paymentStateAbbreviation
		}
	}
`;

export const QUERY = gql`
	${RATE_CARD_FRAGMENT}
	${PRODUCT_PRICE_INFO_FRAGMENT}
	${STORED_PAYMENT_METHODS_FRAGMENT}

	query getRateCard(
		$userId: String!,
		$platform: Platform!,
		$productType: ProductType!,
		$productSubtype: ProductSubType!,
		$isIntroductoryOffers: Boolean,
	) {
			user(id: $userId) {
				id
				rateCard(
					platform: $platform
					productType: $productType
					productSubtype: $productSubtype
					isIntroductoryOffers: $isIntroductoryOffers
				) {
					...RateCardFragment
					productPriceInfoList {
						...ProductPriceInfoFragment
					}
					introductoryOffersPriceInfoList {
						...ProductPriceInfoFragment
						formattedInitialPriceWithoutDiscount
					}
				}
			storedPaymentMethods {
				...StoredPaymentMethodsFragment
			}
			paymentStateAbbreviation
		}
	}
`;

export const PAYPAL_URL_QUERY = gql`
	query getPayPalURL(
		$userId: String!,
		$platform: Platform!,
		$productId: String!,
		$returnURL: String!,
		$cancelURL: String!,
	) {
		user(id: $userId) {
			id
			payPalURL(
				platform: $platform
				productId: $productId
				returnURL: $returnURL
				cancelURL: $cancelURL
			)
		}
	}
`;

export const CREDIT_CARD_PURCHASE_MUTATION = gql`
	mutation purchaseWithCreditCard($input: BillingPurchaseWithCreditCardInput) {
		purchaseWithCreditCard(input: $input) {
			success
			message
		}
	}
`;

export const PAYPAL_PURCHASE_MUTATION = gql`
	mutation purchaseWithPayPal($input: BillingPurchaseWithPayPalInput) {
		purchaseWithPayPal(input: $input) {
			success
			message
		}
	}
`;



// WEBPACK FOOTER //
// ./src/apps/payment/containers/AndroidPayment/queries.js